export default __webpack_public_path__ + "static/media/Logo-Slogan-englisch.43bf0411.png";